import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import App from "App";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import keycloak from "authentication/keycloak";
import store from "redux/store";
import { Provider } from "react-redux";

ReactDOM.render(
  <ReactKeycloakProvider
    authClient={keycloak}
    initOptions={{ checkLoginIframe: false }}
  >
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
  </ReactKeycloakProvider>,
  document.getElementById("root")
);

reportWebVitals();
